function initHomeProjectsTrack() {
  var section = document.querySelector('[data-home-projects]');
  if (!section) return;

  section.classList.add('is-visible');

  if (window.Shopify && window.Shopify.designMode) return;

  var track = section.querySelector('.home-projects-track');
  var trackWrap = track && track.parentElement;
  if (!track || !trackWrap) return;

  var cards = track.getElementsByClassName('home-project-card');
  var links = track.querySelectorAll('.home-project-link');

  var dragging = false;
  var animationFrame = null;
  var mouseSensitivity = 0.3;
  var touchSensitivity = 0.095;

  var isTouch = false;
  var activeTouchDrag = false;
  var touchStartX = 0;
  var touchStartY = 0;
  var lastClientX = 0;
  var isHorizontalDrag = false;
  var dragDirectionDecided = false;
  var directionThreshold = 8;
  var dragDistance = 0;
  var suppressClick = false;

  var velocity = 0;
  var lastMoveTime = 0;
  var lastMoveX = 0;
  var inertiaFrame = null;
  var pendingPointerX = null;

  var currentOffsetPx = 0;
  var prevOffsetPx = 0;
  var cachedTrackWidthPx = 0;
  var cachedGap = 0;

  var isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
  var inertiaDecay = isTouchDevice ? 0.94 : 0.975;
  var mobileInertiaDecay = 0.94;
  var minVelocity = isTouchDevice ? 0.2 : 0.075;
  var mobileLayout = window.matchMedia('(max-width: 756px)');
  var nativeScroll = false;
  var scrollBounds = { min: 0, max: 0 };
  var resizeTimer = null;

  function usesNativeScroll() {
    return mobileLayout.matches;
  }

  function yTranslate() {
    return '-50%';
  }

  function cacheMetrics() {
    var styles = getComputedStyle(track);
    cachedGap = parseFloat(styles.gap) || 0;
    cachedTrackWidthPx = Array.from(cards).reduce(function (sum, card) {
      return sum + card.offsetWidth;
    }, 0);
    cachedTrackWidthPx += cachedGap * Math.max(0, cards.length - 1);
  }

  function waitForImages() {
    var imgElements = Array.from(cards)
      .map(function (card) {
        return card.querySelector('.home-project-image');
      })
      .filter(Boolean);

    if (!imgElements.length) return Promise.resolve();

    var promises = imgElements.map(function (img) {
      if (img.complete && img.naturalWidth) return Promise.resolve();
      return new Promise(function (resolve) {
        img.addEventListener('load', resolve, { once: true });
        img.addEventListener('error', resolve, { once: true });
      });
    });

    // Safari with loading="lazy" can stall load events for off-screen images,
    // blocking applyInteractionMode indefinitely. Race against a timeout so
    // the carousel is always initialised, even if some images are still pending.
    var timeout = new Promise(function (resolve) { setTimeout(resolve, 800); });
    return Promise.race([Promise.all(promises), timeout]);
  }

  function getViewportCenterX() {
    var sectionRect = trackWrap.getBoundingClientRect();
    return sectionRect.left + sectionRect.width / 2;
  }

  function measureAtOrigin(measureFn) {
    var prevTransform = track.style.transform;
    track.style.transform = 'translate3d(0px, ' + yTranslate() + ', 0)';
    var result = measureFn();
    track.style.transform = prevTransform;
    return result;
  }

  function getCenterOffsetPxForIndex(idx) {
    if (!cards.length || idx < 0 || idx >= cards.length) return 0;

    return measureAtOrigin(function () {
      var trackRect = track.getBoundingClientRect();
      var sectionCenterX = getViewportCenterX();
      var x = trackRect.left;

      for (var i = 0; i < idx; i++) {
        x += cards[i].offsetWidth + cachedGap;
      }

      var targetCenterX = x + cards[idx].offsetWidth / 2;
      return sectionCenterX - targetCenterX;
    });
  }

  function getCenterTrackOffsetPx() {
    if (!cards.length || cachedTrackWidthPx <= 0) return 0;

    return measureAtOrigin(function () {
      var trackRect = track.getBoundingClientRect();
      var trackCenterX = trackRect.left + cachedTrackWidthPx / 2;
      return getViewportCenterX() - trackCenterX;
    });
  }

  function updateScrollBounds() {
    if (!cards.length) return;

    scrollBounds.max = getCenterOffsetPxForIndex(0);
    scrollBounds.min = getCenterOffsetPxForIndex(cards.length - 1);

    if (scrollBounds.min > scrollBounds.max) {
      var swap = scrollBounds.min;
      scrollBounds.min = scrollBounds.max;
      scrollBounds.max = swap;
    }
  }

  function clampOffsetPx(offsetPx) {
    if (scrollBounds.max <= scrollBounds.min) {
      return offsetPx;
    }
    return Math.max(Math.min(offsetPx, scrollBounds.max), scrollBounds.min);
  }

  function renderTransform() {
    track.style.transform =
      'translate3d(' + currentOffsetPx + 'px, ' + yTranslate() + ', 0)';
  }

  function setTransformPx(offsetPx) {
    if (!isFinite(offsetPx)) offsetPx = 0;
    currentOffsetPx = clampOffsetPx(offsetPx);
    track.dataset.offsetPx = String(currentOffsetPx);
    renderTransform();
  }

  function centerImageAtIndex(idx) {
    if (!cards.length || idx < 0 || idx >= cards.length) return;

    cacheMetrics();
    updateScrollBounds();
    prevOffsetPx = clampOffsetPx(getCenterOffsetPxForIndex(idx));
    track.dataset.prevOffsetPx = String(prevOffsetPx);
    setTransformPx(prevOffsetPx);
  }

  function centerTrack() {
    if (!cards.length) return;

    cacheMetrics();
    updateScrollBounds();
    prevOffsetPx = clampOffsetPx(getCenterTrackOffsetPx());
    track.dataset.prevOffsetPx = String(prevOffsetPx);
    setTransformPx(prevOffsetPx);
  }

  function centerNativeScroll() {
    requestAnimationFrame(function () {
      var maxScroll = Math.max(0, trackWrap.scrollWidth - trackWrap.clientWidth);
      trackWrap.scrollLeft = maxScroll / 2;
    });
  }

  function applyInteractionMode() {
    nativeScroll = usesNativeScroll();
    section.classList.toggle('home-projects--native-scroll', nativeScroll);

    if (nativeScroll) {
      if (inertiaFrame) {
        cancelAnimationFrame(inertiaFrame);
        inertiaFrame = null;
      }
      dragging = false;
      track.classList.remove('is-dragging');
      track.style.transform = 'none';
      track.style.willChange = 'auto';
      centerNativeScroll();
      return;
    }

    track.style.touchAction = 'none';
    currentOffsetPx = parseFloat(track.dataset.offsetPx || '0');
    prevOffsetPx = currentOffsetPx;
    centerTrack();
  }

  function setLenisPaused(paused) {
    if (nativeScroll) return;
    var lenis = window.lenis;
    if (!lenis) return;
    if (paused && typeof lenis.stop === 'function') lenis.stop();
    else if (!paused && typeof lenis.start === 'function') lenis.start();
  }

  function setDraggingState(active) {
    dragging = active;
    track.classList.toggle('is-dragging', active);
    track.style.willChange = active ? 'transform' : '';
    setLenisPaused(active);
  }

  function dragDeltaToOffsetPx(mouseDelta) {
    var maxDelta = getDragMaxDelta();
    var sensitivity = isTouch ? touchSensitivity : mouseSensitivity;
    return (-mouseDelta * sensitivity / maxDelta) * cachedTrackWidthPx;
  }

  function velocityToOffsetPx(vel) {
    var maxDelta = getDragMaxDelta();
    var sensitivity = isTouch ? touchSensitivity : mouseSensitivity;
    return (vel * sensitivity / maxDelta) * cachedTrackWidthPx;
  }

  function getDragMaxDelta() {
    return window.innerWidth / 2;
  }

  function scheduleDragFrame(clientX) {
    pendingPointerX = clientX;
    if (animationFrame) return;

    animationFrame = requestAnimationFrame(function () {
      animationFrame = null;
      if (!dragging || pendingPointerX === null) return;

      lastClientX = pendingPointerX;
      pendingPointerX = null;

      var mouseDelta = parseFloat(track.dataset.mouseDownAt) - lastClientX;
      dragDistance = Math.max(dragDistance, Math.abs(mouseDelta));
      currentOffsetPx = clampOffsetPx(prevOffsetPx + dragDeltaToOffsetPx(mouseDelta));
      renderTransform();
    });
  }

  function handleOnDown(e) {
    if (e.target.closest && e.target.closest('.home-project-link')) return;
    if (nativeScroll || !track.contains(e.target)) return;

    if (inertiaFrame) {
      cancelAnimationFrame(inertiaFrame);
      inertiaFrame = null;
    }

    // If applyInteractionMode ran before images were laid out (e.g. Safari lazy-load
    // stall), cachedTrackWidthPx may be 0, making all drag deltas produce 0 movement.
    // Re-cache now that the user is interacting and layout is guaranteed to be ready.
    if (!cachedTrackWidthPx) {
      cacheMetrics();
      updateScrollBounds();
    }

    velocity = 0;
    lastMoveTime = 0;
    lastMoveX = 0;
    dragDistance = 0;
    suppressClick = false;
    pendingPointerX = null;
    setDraggingState(true);
    isTouch = e.type.indexOf('touch') === 0;
    activeTouchDrag = isTouch;

    // On desktop Safari, a mousedown near rendered image content can trigger the
    // browser's native drag-and-drop mode before dragstart fires, which silently
    // suppresses subsequent mousemove events. Preventing the mousedown default
    // stops that without affecting click events, which fire on mouseup regardless.
    if (!isTouch && e.cancelable) {
      e.preventDefault();
    }

    var downX = e.clientX || (e.touches && e.touches[0].clientX) || 0;
    track.dataset.mouseDownAt = downX;
    // Use the in-memory value — it's always current even mid-inertia,
    // whereas track.dataset.offsetPx is only written when inertia settles.
    prevOffsetPx = currentOffsetPx;

    if (isTouch && e.touches && e.touches.length) {
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
      lastClientX = touchStartX;
      isHorizontalDrag = false;
      dragDirectionDecided = false;
    } else {
      lastClientX = downX;
      isHorizontalDrag = true;
      dragDirectionDecided = true;
    }
  }

  function handleOnUp() {
    if (nativeScroll || !dragging) return;

    if (dragDistance > 8) {
      suppressClick = true;
    }

    track.dataset.offsetPx = String(currentOffsetPx);
    track.dataset.prevOffsetPx = String(currentOffsetPx);
    prevOffsetPx = currentOffsetPx;

    setDraggingState(false);
    isTouch = false;
    pendingPointerX = null;

    if (animationFrame) {
      cancelAnimationFrame(animationFrame);
      animationFrame = null;
    }

    isHorizontalDrag = false;
    dragDirectionDecided = false;

    if (Math.abs(velocity) > minVelocity) {
      inertiaFrame = requestAnimationFrame(applyInertia);
    } else {
      activeTouchDrag = false;
    }
  }

  function handleOnMove(e) {
    if (nativeScroll || !dragging) return;

    var clientX;
    var clientY;

    if (isTouch && e.touches && e.touches.length) {
      clientX = e.touches[0].clientX;
      clientY = e.touches[0].clientY;

      if (!dragDirectionDecided) {
        var dx = Math.abs(clientX - touchStartX);
        var dy = Math.abs(clientY - touchStartY);
        if (dx > directionThreshold || dy > directionThreshold) {
          isHorizontalDrag = dx > dy;
          dragDirectionDecided = true;
        }
      }

      if (isHorizontalDrag && e.cancelable) {
        e.preventDefault();
      }

      if (!isHorizontalDrag) return;
    } else {
      clientX = e.clientX || 0;
      clientY = 0;
      isHorizontalDrag = true;
    }

    var now = performance.now();
    if (lastMoveTime) {
      var dt = now - lastMoveTime;
      if (dt > 0) {
        var instantVelocity = (clientX - lastMoveX) / dt;
        velocity = velocity * 0.65 + instantVelocity * 0.35;
      }
    }
    lastMoveTime = now;
    lastMoveX = clientX;

    scheduleDragFrame(clientX);
  }

  function applyInertia() {
    if (nativeScroll || dragging) return;

    currentOffsetPx = clampOffsetPx(currentOffsetPx + velocityToOffsetPx(velocity));
    track.dataset.offsetPx = String(currentOffsetPx);
    renderTransform();
    velocity *= mobileLayout.matches && activeTouchDrag ? mobileInertiaDecay : inertiaDecay;

    if (
      Math.abs(velocity) > minVelocity &&
      currentOffsetPx > scrollBounds.min &&
      currentOffsetPx < scrollBounds.max
    ) {
      inertiaFrame = requestAnimationFrame(applyInertia);
    } else {
      velocity = 0;
      inertiaFrame = null;
      activeTouchDrag = false;
      track.dataset.offsetPx = String(currentOffsetPx);
      track.dataset.prevOffsetPx = String(currentOffsetPx);
      prevOffsetPx = currentOffsetPx;
    }
  }

  track.addEventListener(
    'click',
    function (e) {
      if (!suppressClick) return;
      e.preventDefault();
      e.stopPropagation();
      suppressClick = false;
    },
    true
  );

  links.forEach(function (link) {
    link.addEventListener('dragstart', function (e) {
      e.preventDefault();
    });
  });

  track.addEventListener('dragstart', function (e) {
    e.preventDefault();
  });

  track.addEventListener('mousedown', handleOnDown);
  window.addEventListener('mouseup', handleOnUp);
  window.addEventListener('mousemove', handleOnMove);

  track.addEventListener('touchstart', handleOnDown, { passive: true });
  track.addEventListener('touchend', handleOnUp, { passive: true });
  track.addEventListener('touchcancel', handleOnUp, { passive: true });
  track.addEventListener('touchmove', handleOnMove, { passive: false });

  function scheduleResize() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(applyInteractionMode, 120);
  }

  waitForImages().then(applyInteractionMode);

  window.addEventListener('resize', scheduleResize);

  if (mobileLayout.addEventListener) {
    mobileLayout.addEventListener('change', applyInteractionMode);
  } else if (mobileLayout.addListener) {
    mobileLayout.addListener(applyInteractionMode);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initHomeProjectsTrack);
} else {
  initHomeProjectsTrack();
}
